"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getZOrder = getZOrder;
function getZOrder(x, y, z) {
    return x * 1000 + y * 1000 + z;
}
